import React, { useEffect, useState } from 'react';
import moment from 'moment';

import FilterTwoSelectsButton from '../../../../../../components/Molecules/Filter/FilterTwoSelectsButton';
import MbeCalendar from '../../../../../../components/Molecules/Calendar/MbeCalendar';

import { toast } from "react-toastify";
import { ConvertObjectToUrlParams } from "../../../../../../utils/StringUtils";
import { ConvertTasksToFullcalendarEvents, ConvertVisitsToFullCalendarEvents } from '../../../../../../utils/TaskUtils';

import TaskService from '../../../../../../services/TaskService';
import CollaboratorService from '../../../../../../services/CollaboratorService';
import getUserService from "../../../../../../services/getUser";
import {dataRegionsArray} from "../../../../../../utils/RegionsUtils";

const ResCalendarPart = () => {
  const userId = getUserService.getUserId();
  const nextYear = moment().add(1, 'y').format('YYYY-MM-DD')
  
  const firstSelectDefaultValue = "Toutes les agences";
  const firstSelectValue = dataRegionsArray;
  const firstSelectOptions = dataRegionsArray;
  const [region, setRegion] = useState("");
  const filterByRegion = (event) => {
    if (event.target.value === "Toutes les agences") {
      setRegion("")
    } else {
      setRegion(event.target.value)
    }
  }
  
  const [visits, setVisits] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [isAssignment, setIsAssignment] = useState(false);
  const secondSelectDefaultValue = "Toutes les visites";
  const [collaborators, setCollaborators] = useState([]);
  const [collaboratorFilter, setCollaboratorFilter] = useState(userId);
  const filterByCollaborator = (event) => {
    if (event.target.value === "Tous les collaborateurs") {
      setCollaboratorFilter("")
      setIsAssignment(true)
    } else if (event.target.value === "Toutes les visites") {
      setCollaboratorFilter("")
      setIsAssignment(false)
    } else {
      setCollaboratorFilter(event.target.value)
      setIsAssignment(true)
    }
  }

  useEffect(() => {
    const getAssignments = async () => {
      let extraParams = "category.type[]=task-project-com-quote&category.type[]=task-project-com-prospection&category.type[]=task-project-com-meeting&category.type[]=task-project-com-call";
      let urlParams = `${extraParams}&user.id=${collaboratorFilter}&pagination=false&endAt[before]=${nextYear}}`;
      if (region !== "") {
        urlParams = `${urlParams}&region=${region}`
      
      }
      const request = await TaskService.getAllTasks("tasks?" + urlParams)
      if (request.request.status === 200) {
        let assignments = request.data['hydra:member'];
        let availableAssignments = []
        assignments.forEach(assignment => {
          if (assignment.user.roles[0] !== "ROLE_COM_DIR") {
            availableAssignments.push(assignment)
          }
        })
        assignments = ConvertTasksToFullcalendarEvents(availableAssignments)
        setAssignments(assignments)
      } else {
        toast.error("Une erreur est survenue lors de la récupération des tâches")
      }
    };
    getAssignments();

    const getVisits = async () => {
      const request = await TaskService.getTasksUser("visits", { 'region': region, "pagination": "false", "endAt[before]": nextYear })
      if (request.request.status === 200) {
        let visits = request.data['hydra:member'];
        visits = ConvertVisitsToFullCalendarEvents(visits)
        setVisits(visits)
      } else {
        toast.error("Une erreur est survenue lors de la récupération des visites")
      }
    };
    getVisits();

    const getCollaborators = async () => {
      const urlCom = ConvertObjectToUrlParams("coms", { regions: region })
      const request = await CollaboratorService.getCollaborators(urlCom)
      if (request.request.status === 200) {
        let coms = request.data['hydra:member'].filter(collaborator => collaborator.id !== userId)
        let availableComs = []
        coms.forEach(com => {
          if (com.roles[0] !== "ROLE_COM_DIR") {
            availableComs.push(com)
          }
        })
        setCollaborators(availableComs)

      } else {
        toast.error("Une erreur est survenue lors de la récupération de liste des collaborateurs")
      }
    }
    getCollaborators()

  }, [collaboratorFilter, region, userId, isAssignment, nextYear]);


  return (
    <>
      <FilterTwoSelectsButton
        firstOnChange={filterByRegion}
        defaultValue={firstSelectDefaultValue}
        firstValue={firstSelectValue}
        options={firstSelectOptions}
        secondOnChange={filterByCollaborator}
        
        secondDefaultValue={secondSelectDefaultValue}
        isTasksCollaboratorFilter={true}
        
        secondValue={collaborators.map(collaborators => collaborators.id)}
        secondOptions={collaborators.map(collaborator => collaborator.firstname + " " + collaborator.lastname)}
      />
      <MbeCalendar
        tasks={isAssignment ? assignments : visits}
        taskManager={false}
        withNotifications={false}
      />
    </>
  )
}

export default ResCalendarPart;